import React, { useState, useRef, useEffect } from "react";
import UplaodIcon from "Assets/Images/upload.svg";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { AddFinancialStatement } from "Services/OtherApis";

const AddBOD = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [language, setSelectedLanguage] = useState(isRTL ? "ar" : "en");
  const fileInputRefEnglish = useRef(null);
  const fileInputRefArabic = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileNameEnglish, setFileNameEnglish] = useState("");
  const [fileNameArabic, setFileNameArabic] = useState("");
  const [fileLableEnglish, setFileLableEnglish] = useState("");
  const [fileLableArabic, setFileLableArabic] = useState("");
  const [fileEnglish, setFileEnglish] = useState("");
  const [fileArabic, setFileArabic] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateData()) {
      postJob({
        fileName: {
          ar: fileLableArabic,
          en: fileLableEnglish,
        },
        file: {
          ar: fileArabic,
          en: fileEnglish,
        },
        type: "BoardsOfDirecterReport",
      });
    }
  };
  function handleClickEnglish() {
    fileInputRefEnglish.current.click();
  }

  function handleClickArabic() {
    fileInputRefArabic.current.click();
  }

  function handleSelectPDFEnglish(e) {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];

      if (selectedFile.size > 5 * 1024 * 1024) {
        toast.error(t("Please upload a PDF smaller than 5MB."));
        e.target.value = null;
        return;
      }

      if (selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64PDF = event.target.result;
          setFileEnglish(base64PDF);
          setFileNameEnglish(selectedFile.name); // ✅ Set file name
        };

        reader.readAsDataURL(selectedFile);
      } else {
        toast.error(t("Only PDF files are allowed."));
        e.target.value = null;
      }
    }
  }

  function handleSelectPDFArabic(e) {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];

      if (selectedFile.size > 5 * 1024 * 1024) {
        toast.error(t("Please upload a PDF smaller than 5MB."));
        e.target.value = null;
        return;
      }

      if (selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64PDF = event.target.result;
          setFileArabic(base64PDF);
          setFileNameArabic(selectedFile.name); // ✅ Set file name
        };

        reader.readAsDataURL(selectedFile);
      } else {
        toast.error(t("Only PDF files are allowed."));
        e.target.value = null;
      }
    }
  }
  function reset() {
    setFileEnglish("");
    setFileArabic("");
    setFileNameEnglish("");
    setFileNameArabic("");
    setFileLableEnglish("");
    setFileLableArabic("");
    if (fileInputRefEnglish.current) {
      fileInputRefEnglish.current.value = null;
    }
    if (fileInputRefArabic.current) {
      fileInputRefArabic.current.value = null;
    }
  }
  async function postJob(data) {
    setIsLoading(true);
    try {
      const res = await AddFinancialStatement(data, language);
      if (res?.status === 200) {
        toast.success(res?.message || t("Statements Added successfully!"));
        // navigate("/");
        reset();
      } else {
        toast.error(res || t("Error Adding Statements!"));
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }

  const validateData = () => {
    if (fileEnglish === "") {
      toast.error("Please upload English BOD File!");
      return false;
    }

    if (fileArabic === "") {
      toast.error("Please upload Arabic BOD File!");
      return false;
    }
    if (fileLableArabic === "") {
      toast.error("Please upload English BOD Name!");
      return false;
    }

    if (fileLableArabic === "") {
      toast.error("Please upload Arabic BOD Name!");
      return false;
    }

    return true;
  };
  return (
    <div className="w-full mx-auto p-6 bg-white shadow-md rounded-lg">
      <div className="flex flex-row justify-between items-center mb-2">
        <h2 className=" mb-4 font-semibold text-xl  tracking-wide">
          {t("Add Board of Director")}
        </h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <div className="flex flex-row space-x-5 rtl:space-x-reverse">
            <div className="w-1/2">
              <input
                placeholder={t("Enter English Lable")}
                className="w-full py-2 mb-2 px-2  border border-gray-300 rounded-md focus:outline-none "
                onChange={(e) => setFileLableEnglish(e.target.value)}
                value={fileLableEnglish}
              />
              <div
                onClick={handleClickEnglish}
                className="w-full border h-60 cursor-pointer bg-secondry rounded-md border-dashed	 border-gray-200 items-center flex flex-col justify-center px-4 py-8"
              >
                {!fileEnglish && <img src={UplaodIcon} />}
                {fileEnglish && (
                  <IoCheckmarkCircleOutline className="text-6xl text-primary" />
                )}

                {fileEnglish ? (
                  <div className="flex flex-col items-center justify-center">
                    <a className="font-semibold mt-3">
                      <span className="underline text-indigo-800 font-bold cursor-pointer hover:opacity-80 duration-300">
                        {t("Selected English Statement")}
                        <span className="px-1 text-red-500">*</span>
                      </span>
                    </a>
                    <a className="text-xs text-gray-600 dark:text-dark0 mt-3">
                      {fileNameEnglish}
                    </a>
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center">
                    <a className="font-semibold mt-3">
                      <span className="underline text-indigo-800 font-bold cursor-pointer hover:opacity-80 duration-300">
                        {t("Browse in English")}
                        <span className="px-1 text-red-500">*</span>
                      </span>
                    </a>
                    <a className="text-xs text-gray-600 dark:text-dark0 mt-3">
                      {t("Supported format: PDF only")}
                    </a>
                  </div>
                )}
              </div>
            </div>

            <div className="w-1/2">
              <input
                placeholder={t("Enter Arabic Lable")}
                className="w-full py-2 mb-2 px-2  border border-gray-300 rounded-md focus:outline-none "
                onChange={(e) => setFileLableArabic(e.target.value)}
                value={fileLableArabic}
              />
              <div
                onClick={handleClickArabic}
                className="w-full border h-60 cursor-pointer bg-secondry rounded-md border-dashed	 border-gray-200 items-center flex flex-col justify-center px-4 py-8"
              >
                {!fileArabic && <img src={UplaodIcon} />}
                {fileArabic && (
                  <IoCheckmarkCircleOutline className="text-6xl text-primary" />
                )}
                {fileArabic ? (
                  <div className="flex flex-col items-center justify-center">
                    <a className="font-semibold mt-3">
                      <span className="underline text-indigo-800 font-bold cursor-pointer hover:opacity-80 duration-300">
                        {t("Selected Arabic Statement")}
                        <span className="px-1 text-red-500">*</span>
                      </span>
                    </a>
                    <a className="text-xs text-gray-600 dark:text-dark0 mt-3">
                      {fileNameArabic}
                    </a>
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center">
                    <a className="font-semibold mt-3">
                      <span className="underline text-indigo-800 font-bold cursor-pointer hover:opacity-80 duration-300">
                        {t("Browse in Arabic")}
                        <span className="px-1 text-red-500">*</span>
                      </span>
                    </a>
                    <a className="text-xs text-gray-600 dark:text-dark0 mt-3">
                      {t("Supported format: PDF only")}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
          <input
            ref={fileInputRefEnglish}
            type="file"
            accept="application/pdf"
            onChange={handleSelectPDFEnglish}
            style={{ display: "none" }}
          />
          <input
            ref={fileInputRefArabic}
            type="file"
            accept="application/pdf"
            onChange={handleSelectPDFArabic}
            style={{ display: "none" }}
          />
        </div>

        <div className="flex items-center">
          <button
            type="submit"
            className={`mt-4 px-4 py-2 rounded-md ml-auto flex items-center justify-center ${
              isLoading ? "bg-gray-500 cursor-not-allowed" : "bg-indigo-800"
            } text-white`}
            disabled={isLoading} // Disable button when loading
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4l-3 3 3 3v-4z"
                  ></path>
                </svg>
                {t("Loading...")}
              </>
            ) : (
              t("Submit")
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBOD;
